import { __rest } from "tslib";
import React from 'react';
import MobileStepbar from '../MobileStepbar';
import { OrderStatus } from '@websky/graphql';
const MobileStepbarShowWrapper = (_a) => {
    var { alwaysShowMobileStepbarOnOrderCancelled = true } = _a, props = __rest(_a, ["alwaysShowMobileStepbarOnOrderCancelled"]);
    if (props.order.status === OrderStatus.Cancelled && !alwaysShowMobileStepbarOnOrderCancelled) {
        return null;
    }
    return React.createElement(MobileStepbar, Object.assign({}, props));
};
export default MobileStepbarShowWrapper;
